import React from 'react';
import { TextField, makeStyles } from '@material-ui/core';
import { useTranslation } from 'react-i18next';

const useStyles = makeStyles(theme => ({
  textField: {
    marginBottom: theme.spacing(1)
  },
}));

const InputText = (props) => {
  const classes = useStyles();
  const {
    values,
    touched,
    errors,
    handleChange,
    handleBlur,
    name,
    inputType = "text",
    label,
    margin = "dense",
    variant = "standard",
    inputProps = {},
    labelProps = {},
    className = classes.textField
  } = props;
  const { t } = useTranslation();

  return (
    <TextField
        error={errors[name] && touched[name]}
        type={inputType}
        label={t(label)}
        name={name}
        className={className}
        value={values[name]}
        onChange={handleChange}
        onBlur={handleBlur}
        helperText={errors[name] ? t(errors[name]) : " "}
        fullWidth
        margin={margin}
        variant={variant}
        InputLabelProps={labelProps}
        InputProps={inputProps}
      />
  );
};

export default InputText;
